import React from "react";
import Radium from "radium";
import { colors as Colors } from "material-ui/styles";

const styles = {
  base: {
    cursor: "pointer",
    display: "inline-block",
    fontWeight: "normal",
    padding: "2px 5px",
    lineHeight: "14px",
    fontSize: 11,
    borderRadius: 5,
    border: `1px solid ${Colors.lightBlue700}`,
    color: Colors.lightBlue700,
    transition: "0.1s ease-in-out",
    ":hover": {
      backgroundColor: Colors.lightBlue700,
      color: "#fff"
    }
  }
};

class InlineButton extends React.Component {
  render() {
    const { label, style, onTouchTap, onClick } = this.props;

    return (
      <div
        onClick={onClick}
        onTouchTap={onTouchTap}
        style={[styles.base, style]}
      >
        {label}
      </div>
    );
  }
}

export default Radium(InlineButton);



// WEBPACK FOOTER //
// ./src/app/components/partials/inline-button.jsx